import React from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import { getSubmitOssFormat, removeExpires, showModal } from '../../components/common/utils'
import ApplicantDetailStatus from '../../components/common/ApplicantDetailStatus'
import { isMember } from '../../reducers/selectors'
import { usePayFdi, useSubmitFdi } from '../../services/hooks'
import { useHistory } from 'react-router-dom'

const ApplicationStatus = ({ detail, formData, checkAge, checked, isAutoRenewJump, certComplete, addressComplete }) => {
  const { formatMessage } = useIntl()
  const { push } = useHistory()
  const { runAsync: toPay } = usePayFdi()
  const { runAsync: submitFdi, loading: submitting } = useSubmitFdi()

  const { signatureUrl, ismember } = useSelector((state) => ({
    signatureUrl: state.ui.signatureUrl,
    ismember: isMember(state),
  }))

  const verifyData = () => {
    const { cdinstructorNumber, languageId, finishDate, regionId, address, courseLocation, addressRegionId } = formData
    const regionStatus = ismember ? true : regionId
    return (
      cdinstructorNumber &&
      addressRegionId &&
      addressComplete &&
      address &&
      languageId &&
      finishDate &&
      regionStatus &&
      courseLocation &&
      checkAge &&
      checked &&
      signatureUrl &&
      certComplete
    )
  }

  const submit = () => {
    if (!verifyData()) {
      showModal(
        '',
        formatMessage({ id: 'dm-form-submit-error-info' }),
        () => {},
        () => {},
        formatMessage({ id: 'common-comfirmBtn' }),
        formatMessage({ id: 'common-cancel' })
      )
      return
    }
    const { finishDate, cdinstructorNumber, code, regionId, ...data } = formData
    let submitData = {
      ...data,
      efrfiles: data.efrfiles ? removeExpires(data.efrfiles) : [],
      fdifiles: data.fdifiles ? removeExpires(data.fdifiles) : [],
      otherFiles: data.otherFiles ? removeExpires(data.otherFiles) : [],
      courseDate: finishDate,
      trainerInstructorNumber: cdinstructorNumber,
      handwrittenSignatureUrl: getSubmitOssFormat(signatureUrl),
    }
    if (code) submitData.code = code
    if (!ismember) submitData.regionId = regionId
    submitFdi(submitData).then((res) => {
      if (res.code) {
        let params = {
          code: res.code,
          paid: res.paid,
          paymentType: 'MEMBER_APPLICATION_FDI',
        }
        if (isAutoRenewJump) {
          params.autoRenew = isAutoRenewJump
        }
        push('/application_submit_success?type=FDI', params)
      }
    })
  }

  return (
    <ApplicantDetailStatus
      detail={detail}
      idType={'trainer'}
      submitFn={submit}
      payFn={toPay}
      applicationType={'FDI'}
      payApplicationType={'MEMBER_APPLICATION_FDI'}
      loading={submitting}
    />
  )
}

export default ApplicationStatus
